var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { ToastService } from '@shared/lib/services';
import { prepareResults } from '../utils/prepareResults';
import { validateResults } from '../utils/validateResults';
import { SummaryService } from '../service/Summary.service';
import { groupErrorsByProperty } from '../utils/groupErrorsByProperty';
import { PageTypes } from '@shared/types';
const getInitialState = () => ({
    documentId: undefined,
    document: undefined,
    data: undefined,
    errors: [],
    groupedErrors: undefined,
    selectedRows: [],
    selectableType: PageTypes.certificate
});
export const useSummaryStore = create()(devtools((set, get) => (Object.assign(Object.assign({}, getInitialState()), { fetchSummary: (projectId, id) => __awaiter(void 0, void 0, void 0, function* () {
        if (id) {
            Promise.all([
                SummaryService.getDocument(projectId, id),
                SummaryService.getDocumentEnricher(projectId, id)
            ])
                .then(([document, results]) => {
                const { data, selectableType } = prepareResults(results);
                set({
                    documentId: id,
                    document,
                    data,
                    selectableType,
                    errors: [],
                    groupedErrors: undefined
                });
            })
                .catch(err => ToastService.error(err));
        }
        else {
            try {
                const result = yield SummaryService.getProjectEnricher(projectId);
                const { data, selectableType } = prepareResults(result);
                const { validatedData, errors } = validateResults(data);
                const groupedErrors = groupErrorsByProperty(errors);
                set({
                    data: validatedData,
                    selectableType,
                    errors,
                    groupedErrors
                });
            }
            catch (err) {
                ToastService.error(err);
            }
        }
    }), fetchArchived: (projectId) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const result = yield SummaryService.getArchivedEnricher(projectId);
            const { data, selectableType } = prepareResults(result);
            const { validatedData, errors } = validateResults(data);
            const groupedErrors = groupErrorsByProperty(errors);
            set({
                data: validatedData,
                selectableType,
                errors,
                groupedErrors
            });
        }
        catch (err) {
            ToastService.error(err);
        }
    }), reset: () => set(getInitialState()), setSelectedRows: rows => {
        set({ selectedRows: rows });
    }, updateSummaryData: data => {
        set({ data });
    } }))));
